module.exports = __webpack_public_path__ + "static/media/buffetjm.2330f34b.webp";